import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { useSelector, useDispatch } from 'react-redux'
import { showError } from '../../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	serviceWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 27,
		'& p': {
			width: '50%'
		}
	},
	fieldWrapper: {
		minWidth: '400px !important',
		width: '400px !important',
		marginBottom: 36,
		'& .MuiFilledInput-root': {
			minWidth: '400px !important',
			width: '400px !important'
		},
		'& .MuiTextField-root': {
			minWidth: '400px !important',
			width: '400px !important'
		}
	},
	disableButton: {
		color: '#D02C2C',
		fontSize: '14px',
		lineHeight: '19px',
		borderRadius: '25px',
		marginBottom: 32,
		'&:hover': {
			backgroundColor: 'rgba(208, 44, 44, 0.2)'
		}
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	}
}))

const RemoveCreditDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const facility = useSelector((state) => state.specific.facilities.selected)

	let { selectedCredit, isShown, setIsShown, removeCredits } = props

	const [creditQuantityError, setCreditQuantityError] = useState(false)
	const [creditQuantity, setCreditQuantity] = useState('1')
	const [credit, setCredit] = useState(selectedCredit)

	useEffect(() => {
		if (selectedCredit) {
			setCredit({ ...selectedCredit })
		}
	}, [selectedCredit])

	const closeDialog = () => {
		setCreditQuantity('')
		setCreditQuantityError(false)
		setIsShown(false)
	}

	const setQuantity = (value) => {
		if (!value || parseInt(value) > 99 || parseInt(value) < 1) {
			setCreditQuantityError(true)
		} else {
			setCreditQuantityError(false)
		}

		setCreditQuantity(value)
	}

	const save = () => {
		if (creditQuantityError) {
			dispatch(showError('Please fix form errors.'))
			return
		}

		setCreditQuantityError(false)

		removeCredits({
			facilityId: credit.facilityId ? credit.facilityId : facility._id,
			service: credit.type,
			quantity: creditQuantity
		})

		closeDialog()
	}

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => closeDialog()}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle>REMOVE CREDITS</DialogTitle>
			<DialogContent>
				<div className={classes.serviceWrapper}>
					<Typography variant="overline" style={{ textTransform: 'none' }}>
						Service
					</Typography>
					<Typography variant="body2">{credit ? credit.service : ''}</Typography>
				</div>
				<div className={classes.fieldWrapper}>
					<TextField
						label="Quantity"
						variant="filled"
						type="number"
						InputProps={{ inputProps: { min: 1, max: 99 } }}
						value={creditQuantity}
						onChange={(e) => setQuantity(e.target.value)}
						error={creditQuantityError}
						helperText={creditQuantityError ? 'Quantity must be 1-99.' : null}
					/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={() => save()} color="secondary">
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => closeDialog()} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default RemoveCreditDialog
